/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */

/* eslint-disable no-multi-spaces */

/**
 * Defines the CTC Admin Application keys which are to be used for all iOn specific
 * constant references, such as when initializing User Preferences, getting / setting
 * localStorage values, etc.
 */
export enum ApplicationKeys {
  CTCAdmin        = 'ion-ctc-admin',
  CTCAdminSession = 'ion-ctc-admin-session',
  CTCAdminPage    = 'ion-ctc-admin-page'
};
